// PRO+ hub news ticker: the band's lines scroll across a neon bar (pauses on hover, still for reduced motion).
import { Zap } from "lucide-react";

export const HubTicker = ({ lines = [] }) => {
  if (!lines.length) return null;
  const run = [...lines, ...lines, ...lines];
  return (
    <div className="hub-ticker relative overflow-hidden bg-[#54E3FF] text-[#030608] shadow-[0_0_50px_-10px_rgba(84,227,255,0.7)]" data-testid="hub-ticker" role="marquee" aria-label={lines.join(" · ")}>
      <div className="hub-marquee flex w-max" style={{ animationDuration: `${run.length * 6}s` }}>
        {[0, 1].map((k) => (
          <ul key={k} aria-hidden="true" className="flex shrink-0 items-center m-0 p-0 list-none">
            {run.map((l, i) => (
              <li key={i} className="flex items-center gap-3 px-6 py-2.5 whitespace-nowrap text-[11px] sm:text-xs font-black uppercase tracking-[0.22em]" data-testid={k === 0 && i < lines.length ? `hub-ticker-line-${i}` : undefined}>
                <Zap className="h-3.5 w-3.5 shrink-0" fill="currentColor" /> {l}
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  );
};
